import React, { useState, useEffect, useRef } from 'react';
import { Link as LinkIcon } from 'lucide-react';

const LinkDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [url, setUrl] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (isOpen && editor) {
            const currentUrl = editor.getAttributes('link').href || '';
            setUrl(currentUrl);
        }
    }, [isOpen, editor]);

    const handleSetLink = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!editor) return;
        const trimmedUrl = url.trim();
        if (!trimmedUrl) {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
        } else {
            if (editor.state?.selection?.empty) {
                editor.chain().focus().insertContent({
                    type: 'text',
                    text: trimmedUrl,
                    marks: [{
                        type: 'link',
                        attrs: { href: trimmedUrl, target: '_blank' }
                    }]
                }).run();
            } else {
                editor.chain().focus().extendMarkRange('link').setLink({ href: trimmedUrl, target: '_blank' }).run();
            }
        }
        setIsOpen(false);
    };

    const handleRemoveLink = () => {
        if (!editor) return;
        editor.chain().focus().unsetLink().run();
        setIsOpen(false);
    };

    const isLinkActive = editor?.isActive('link');

    return (
        <div className="list-style-dropdown-container" ref={dropdownRef}>
            <button
                className={`toolbar-btn ${isLinkActive ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                title="Insert Link"
            >
                <LinkIcon size={15} />
                <span className="toolbar-tooltip">Hyperlink</span>
            </button>
            {isOpen && (
                <div className="library-dropdown-menu" style={{ width: '280px', padding: '12px', left: 'auto', right: 0 }}>
                    <div className="library-dropdown-title">Hyperlink Settings</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <input
                            type="text"
                            placeholder="Enter absolute URL (https://...)"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            style={{
                                width: '100%', padding: '6px 10px', border: '1px solid #CBD5E1',
                                borderRadius: '6px', fontSize: '12px', outline: 'none'
                            }}
                        />
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            {isLinkActive && (
                                <button
                                    onClick={handleRemoveLink}
                                    style={{
                                        background: '#FEF2F2', color: '#EF4444', border: 'none',
                                        padding: '6px 12px', borderRadius: '6px', fontSize: '12px',
                                        fontWeight: '600', cursor: 'pointer'
                                    }}
                                >
                                    Remove
                                </button>
                            )}
                            <button
                                onClick={handleSetLink}
                                style={{
                                    background: '#FF5526', color: '#FFFFFF', border: 'none',
                                    padding: '6px 12px', borderRadius: '6px', fontSize: '12px',
                                    fontWeight: '600', cursor: 'pointer'
                                }}
                            >
                                Apply Link
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LinkDropdown;
